import script from "./Aurora.vue?vue&type=script&setup=true&lang=js"
export * from "./Aurora.vue?vue&type=script&setup=true&lang=js"

import "./Aurora.vue?vue&type=style&index=0&id=422d3964&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-422d3964"]])

export default __exports__